<template lang="pug">
  div
    .input-group
      button.btn.btn-link(@click='!disabled && open()')
        btn-content(icon='fa fa-file-image-o' label='Plantas do cadastro')

    .modal.modal-md(:class='{active: active}')
      a.modal-overlay(aria-label='Fechar' @click='close')
      .modal-container
        .modal-header
          span.text-bold Plantas do cadastro {{ cadastro.numero }}
          a.btn.btn-clear.float-right(aria-label='Fechar' @click='close')
        .modal-body
          .content
            spinner.text-center(:loading="loading")
            .columns(v-if='plantas && plantas.length')
              .column.col-6.col-xs-12.py-2(v-for='planta in editaveis' :key='planta.id')
                planta(:class="{'bg-gray': planta.selected}" :planta='planta')
                  .columns(slot='footer')
                    .column
                    .column.col-auto
                      label.form-switch.input-sm
                        input(type="checkbox" v-model='planta.selected' :disabled='isSelected(planta)')
                        i.form-icon
                        | Selecionar
            .empty(v-else)
              .empty-icon
                .fa.fa-search.fa-4x
              .empty-title.h5 Nenhuma planta
        .modal-footer
          .columns.py-2.align-end
            .column.abbr.text-left
              b {{ selecteds.length }}
              span  Selecionada`s
            .column.col-auto
              button.btn.btn-primary(@click='onSelect()' :disabled='selecteds.length < 1')
                btn-content(name='check' label='Adicionar')
</template>

<script>
import OsmPlanta from '@/models/OsmPlanta'
import Planta from './Planta'

export default {
  props: {
    cadastro: { type: Object, required: true },
    disabled: { type: Boolean, default: false },
    plantasSelecionadas: { type: Array, default: () => [] },
  },

  vuex: {
    cadastros: {
      actions: ['fetchPlantas'],
      getters: ['loading'],
      state: ['plantas', 'current', 'status'],
      getters: ['loading'],
    },
  },

  components: { Planta },

  data() {
    return { active: false, editaveis: [] }
  },

  computed: {
    selecteds() {
      return this.editaveis.filter(p => p.selected).map(p => new OsmPlanta(p))
    },
  },

  methods: {
    open() {
      this.active = true
    },
    close() {
      this.active = false
    },

    onSelect() {
      this.$emit('selected', this.selecteds)
      this.close()
    },

    isSelected(planta) {
      if (!this.plantasSelecionadas) return false
      return Boolean(this.plantasSelecionadas.find(a => a.id === planta.id))
    },

    async getPlantas() {
      if (
        this.current &&
        this.current.id === this.cadastro.id &&
        this.plantas.length
      ) {
        this.setEditaveis()
        return
      }
      await this.fetchPlantas({ id: this.cadastro.id })
      this.setEditaveis()
    },

    setEditaveis() {
      this.editaveis = this.plantas.map(p => ({
        ...p,
        selected: this.isSelected(p),
      }))
    },
  },

  mounted() {
    this.getPlantas()
  },
}
</script>
